import { PBanner } from "@porsche-design-system/components-react"
import { defineMessages, useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"

const messages = defineMessages({
	errorCognito: {
		defaultMessage: "An error occurred while getting a PPN id token. Please contact your PPN administrator.",
		id: "error.cognito",
	},
})

export const CognitoErrorBanner = () => {
	const { formatMessage } = useIntl()
	return (
		<PBanner
			open
			dismissButton={false}
			state="error"
			heading={formatMessage(commonMessages.error)}
			description={formatMessage(messages.errorCognito)}
		/>
	)
}
